module.exports = __webpack_public_path__ + "static/img/img-logo-attaqwa.dc0395d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-logo-attaqwa.png
// module id = ZNZZ
// module chunks = 36